import NominalAmount from "./NominalAmount";
class Nominal {
    amount;
    tapAmount;
    constructor(response) {
        this.amount = response.amount !== undefined ? new NominalAmount(response.amount) : undefined;
        this.tapAmount = response.tapAmount !== undefined ? new NominalAmount(response.tapAmount) : undefined;
    }
}
export default Nominal;
